import './brand-icon.css';

import classNames from 'classnames';
import React from 'react';

export function BrandIcon({
	icon,
	iconListColor,
	iconListStyle,
	iconListSize,
}) {
	const iconColor = icon?.iconColor || iconListColor;
	const iconSize = icon?.iconSize || iconListSize;
	const outlineColors = new Set(['black', 'white', 'rust']);
	const iconStyle =
		iconColor === 'empty'
			? 'offsetBlob'
			: outlineColors.has(iconColor)
				? 'outline'
				: icon?.iconStyle || iconListStyle;
	const svg = icon?.icon?.iconSvg || icon?.iconSvg;

	const iconSizeStyle = {
		width: `${iconSize}px`,
		height: `${iconSize}px`,
	};

	return (
		<div className={iconColor}>
			<div
				className={classNames('brand-svg-container', iconStyle)}
				style={{ ...iconSizeStyle }}
				dangerouslySetInnerHTML={{ __html: svg }}
			/>
		</div>
	);
}
